<template>
	<div class="filter-config" ref="root">
		<div class="config-title">
			<span>{{ title }}</span>
			<span class="reset-section" :class="{ active: value.length }" @click="reset">
				重置
			</span>
		</div>
		<div class="config-item-list">
			<div
				v-for="(option, index) in visibleOptions"
				:key="index"
				class="config-item"
				:class="{ selected: value.some(one => one === option.value) }"
				@click="pick(option.value)"
			>
				<slot name="option-left" :option="option" />
				<span class="config-item-label">
					{{ option.label || option.value }}
				</span>
			</div>
			<div v-if="isExpandable" class="config-item expand-item" @click="toggleExpand">
				<span>{{ isExpanded ? '收起' : '展开' }}</span>
				<nio-icon
					class="expand-icon"
					:size="12"
					:name="isExpanded ? 'icon_arrows_top_2xs' : 'icon_arrows_down_2xs'"
				/>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'FilterConfigSection',
	model: {
		prop: 'value',
		event: 'change'
	},
	props: {
		title: {
			type: String,
			default: ''
		},
		options: {
			type: Array,
			default: () => []
		},
		maxVisibleCount: {
			type: Number,
			default: 6
		},
		value: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			isExpanded: false
		}
	},
	computed: {
		isExpandable() {
			return this.maxVisibleCount > 0 && this.options.length > this.maxVisibleCount
		},
		visibleOptions() {
			return this.isExpandable && !this.isExpanded
				? this.options.slice(0, this.maxVisibleCount - 1)
				: this.options
		}
	},
	methods: {
		toggleExpand() {
			this.isExpanded = !this.isExpanded

			this.$nextTick(() => {
				const el = this.$refs.root
				try {
					el.scrollIntoView({ behavior: this.isExpanded ? 'smooth' : 'auto', block: 'start' })
				} catch (e) {
					el.scrollIntoView(true)
				}
			})
		},
		pick(val) {
			const next = this.value.slice()
			const idx = next.indexOf(val)
			if (idx >= 0) {
				next.splice(idx, 1)
			} else {
				next.push(val)
			}
			this.$emit('change', next)
		},
		reset() {
			this.$emit('change', [])
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';

.filter-config {
	.config-title {
		margin-bottom: 10px;
		font-size: 14px;
		line-height: 25px;
		color: $text_primary;

		display: flex;
		justify-content: space-between;
		align-items: center;
		font-weight: 500;

		.reset-section {
			font-weight: 400;
			color: $text_disable;

			&.active {
				color: $text_secondary;
			}
		}
	}

	.config-item-list {
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-gap: 10px;

		.config-item {
			position: relative;
			box-sizing: border-box;
			border: 1px solid #e9ecf1;
			color: $color_mb1_front;

			font-size: 14px;
			line-height: 25px;
			display: flex;
			justify-content: center;
			align-items: center;
			height: 35px;
			overflow: hidden;
			padding: 0 10px;

			.config-item-label {
				display: block;
				min-width: 0;
				max-width: 100%;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}

			.expand-icon {
				margin-left: 5px;
			}

			&.selected {
				border-color: #040b29;
			}
		}
	}
}
</style>
